<template>
    <div v-if="isVisible" :class="['dropdown bo-dropdown-menu', dropdownStyle]">
        <button class="btn bo-dropdown-toggle" type="button" data-toggle="dropdown" id="dropdownMenuButton1">
            <slot v-if="selected" name="selected-item" :item="selected">
                {{ selected.label }}
            </slot>
        </button>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <div
                @click="select(item)"
                v-for="item in value"
                :class="['dropdown-item', { active: selected && selected.id == item.id }]"
                :key="item.index"
            >
                <slot name="item" :item="item">
                    {{ item.label }}
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
        default: {
            type: Object,
            default: () => ({}),
        },
        dropdownStyle: {
            type: String,
            default: "",
        },
    },

    computed: {
        isVisible: {
            get() {
                return this.value && this.value.length;
            },
        },
    },

    data() {
        return {
            visible: false,
            selected: this.default,
        };
    },

    methods: {
        select(item) {
            this.selected = item;
            this.$emit("change", item);
        },
        showDropdown() {
            this.visible = true;
        },
    },
};
</script>
